import { TicketDetail } from "./TicketDetail";

// Detail view for a JBM-portal ticket (uses JBM config).
export const JbmTicket = () => <TicketDetail isRcs={false} />;
